
document.addEventListener('DOMContentLoaded', function() {
  const video = document.getElementById('video-banner');
const videoMobile = document.getElementById('video-banner-mobile');

  const playBtn = document.getElementById('play-btn');
const playBtnMobile = document.getElementById('play-btn-mobile');

  let playLoopActive = true; // Drapeau pour savoir si la boucle est active
  let loopTimeout; // Variable pour stocker le timeout de la boucle

  // Fonction pour démarrer la boucle de lecture automatique
  function playLoop() {
      if (!playLoopActive) return; // Si la boucle est désactivée, on ne continue pas

      video.play(); // Lecture automatique de la vidéo
  videoMobile.play();
      // Arrêter la vidéo
      loopTimeout = setTimeout(() => {
          video.pause();
    videoMobile.pause();
          video.currentTime = 0;
    videoMobile.currentTime = 0;
          playBtn.style.opacity = '1';
    playBtnMobile.style.opacity = '1';

          // Relancer la vidéo automatiquement après 100ms
          setTimeout(() => {
              playLoop(); // Relancer la vidéo depuis le début
              playBtn.style.opacity = '1'; // Cacher le bouton Play
      playBtnMobile.style.opacity = '1';
          }, 100); // Relancer très peu de temps après la pause pour l'effet d'auto-play
      }, 20000);
  }

  // Démarrer la lecture automatique au chargement
  setTimeout(() => {
      video.play(); // Lecture automatique de la vidéo
  videoMobile.play();
      playLoop(); // Lancer la boucle de lecture
  }, 3000); // 3 secondes avant de démarrer la lecture

  // Clic sur le bouton Play
  playBtn.addEventListener('click', function() {
      video.currentTime = 0; // Revenir au début de la vidéo
      video.play(); // Relancer la vidéo

      playLoopActive = false; // Désactiver la fonction playLoop
  playBtn.style.opacity = '0';

      clearTimeout(loopTimeout); // Arrêter la boucle en cours
  });

playBtnMobile.addEventListener('click', function() {
  videoMobile.currentTime = 0;
  videoMobile.play();

      // Désactiver la boucle de lecture
      playLoopActive = false; // Désactiver la fonction playLoop
  playBtnMobile.style.opacity = '0';
      // Clear le timeout en cours pour stopper la boucle
      clearTimeout(loopTimeout); // Arrêter la boucle en cours
  });

});
